import { render } from "./createNewVersion.vue?vue&type=template&id=454b5b58&scoped=true"
import script from "./createNewVersion.js?vue&type=script&lang=js"
export * from "./createNewVersion.js?vue&type=script&lang=js"

import "./createNewVersion.vue?vue&type=style&index=0&id=454b5b58&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454b5b58"]])

export default __exports__